// assets/wow-cart-fixes.js
(function () {
  'use strict';
  try {
    // Short helper to strip only trailing .00 from a price string
    function stripTrailingZeroCents(text) {
      if (!text || typeof text !== 'string') return text;
      return text.replace(/\.00(?!\d)/g, '');
    }

    // Update price nodes within a root element
    function formatPrices(root) {
      if (!root) return;
      var selectors = [
        '.ufe-cart-item-original-price .money',
        '.ufe-cart-item-total-price.money',
        '.ufe-cart-total-price.money',
        '.wow-cart-product-quantity__final-price .money',
        '.wow-cart-product__sale-price .money',
        '.wow-cart-product-price-block .money',
        '.wow-cart-subtotal-wrapper .money',
        '.wow-cart-product-item .money'
      ];
      selectors.forEach(function (sel) {
        var nodes = root.querySelectorAll ? root.querySelectorAll(sel) : [];
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          var original = el.textContent;
          var formatted = stripTrailingZeroCents(original);
          if (formatted !== original) el.textContent = formatted;
        }
      });
    }

    // Fix "Items" vs "Item"
    function fixItemLabel(root) {
      var el = (root && root.querySelector) ? root.querySelector('.wow-cart-products-count') : document.querySelector('.wow-cart-products-count');
      if (!el) return;
      var match = el.textContent.trim().match(/\d+/);
      if (!match) return;
      var count = parseInt(match[0], 10) || 0;
      el.textContent = count === 1 ? '1 Item' : (count + ' Items');
    }

    // Combined formatter
    function runFormatting(root) {
      try {
        formatPrices(root || document);
        fixItemLabel(root || document);
      } catch (e) {
        // swallow — nothing critical
        console && console.warn && console.warn('wow-cart-fixes: formatting error', e);
      }
    }

    // Debounce helper
    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    // Prefer observing the drawer container to reduce overhead; fallback to body
    function findDrawerRoot() {
      return document.querySelector('.wow-cart-box-out-bar') || document.querySelector('.wow-cart-wrapper') || document.body;
    }

    // Initial run on load and when DOM becomes interactive
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      runFormatting(findDrawerRoot());
    } else {
      window.addEventListener('DOMContentLoaded', function () { runFormatting(findDrawerRoot()); }, { passive: true });
    }

    // Observe the cart area for changes (debounced)
    var observerRoot = findDrawerRoot();
    var debouncedRun = debounce(function () { runFormatting(observerRoot || document); }, 80);

    var mo = new MutationObserver(function (mutations) {
      // Only react if nodes are added/changed, not every tiny mutation
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) { relevant = true; break; }
        if (m.type === 'characterData') { relevant = true; break; }
      }
      if (relevant) debouncedRun();
    });

    mo.observe(observerRoot || document.body, { childList: true, subtree: true, characterData: true });

    // Also run when window regains focus (drawer may open after navigation)
    window.addEventListener('focus', function () { runFormatting(findDrawerRoot()); }, { passive: true });

    // Expose a safe global to manually trigger if needed
    window.__wowCartFixes = { run: function () { runFormatting(findDrawerRoot()); } };

  } catch (err) {
    // If anything fatal occurs, log but do not throw (prevents breaking other scripts)
    console && console.error && console.error('wow-cart-fixes init failed', err);
  }
})();
